import React, { useState } from "react";
import "./Smm.css";
import { IoMdClose } from "react-icons/io";

export default function PricingPlans() {
  const [activeTab, setActiveTab] = useState("monthly"); // monthly | quarterly | halfyear | yearly
  const [selectedPlan, setSelectedPlan] = useState(null);

  // Shared full details (same across durations)
  const fullDetails = {
    resources: [
      { label: "Dedicated Resources", value: "" }, // values updated per plan below
    ],
    setup: [
      "WhatsApp Group Creation - Team Collaboration ✔",
      "0 Day Report for MOM Growth Comparison ✔",
      "Google Analytics - Setup and Review ✔",
      "Google Search Console - Setup and Review ✔",
      "Google Penalty Check ✔",
      "Website Indexing Check ✔",
      "Business Brief Meeting ✔",
      "Sitemap Submission ✔"
    ],
    onpage_seo: [],
    offpage_seo: [],
    technical_seo: [],
    reporting: [],
    support: []
  };

  // Build full details per plan (from screenshots)
  const planDetails = {
    lite: {
      resources: [
        { label: "Dedicated Resources", value: "1" },
        { label: "Social Media Executive", value: "1" },
        { label: "Asst. Executive", value: "❌" },
        { label: "Shared Resources", value: "2" },
        { label: "Account Manager", value: "❌" },
        { label: "Graphic Designer", value: "1" },
        { label: "Copy Writer", value: "1" }
      ],

      account_setup_and_integration: [
        { label: "Social Media Profiles Setup", value: "4 Platforms" },
        { label: "Integration with Website", value: "❌" },
        { label: "Number of Platforms", value: "4 Platforms" },
        { label: "Initial Setup & Strategy", value: "❌" },
        { label: "WhatsApp Group Creation - Team Collaboration", value: "✔" },
        { label: "Day Report for MOM Growth Comparison", value: "✔" },
        { label: "Business Brief Meeting", value: "✔" },
        { label: "Account Creation/Overhaul", value: "✔" },
        { label: "Audience Research", value: "Basic" },
        { label: "Campaign Strategy Development", value: "Basic" }
      ],

      content_creation_and_posting: [
        { label: "Content Calendar", value: "Monthly" },
        { label: "Posts per Month", value: "8" },
        { label: "Posting Frequency", value: "2 times/week" },
        { label: "Cover Photo & Profile Update", value: "Annual" },
        { label: "Stories Creation", value: "❌" },
        { label: "Interactive Posts (Polls, Quizzes)", value: "❌" },
        { label: "Video Posts", value: "❌" }
      ],

      engagement: [
        { label: "Direct Messaging / Response Handling", value: "❌" },
        { label: "Comment Response", value: "❌" },
        { label: "Influencer Collaboration", value: "❌" },
        { label: "Group Creation & Management", value: "❌" },
        { label: "Community Group Engagement", value: "❌" }
      ],

      additional_features: [
        { label: "Social Media Training for Staff", value: "❌" },
        { label: "Crisis Management", value: "❌" },
        { label: "Social Media Policy Development", value: "❌" },
        { label: "Multilingual Posts", value: "❌" },
        { label: "Platform-Specific Strategy (e.g., LinkedIn)", value: "❌" },
        { label: "VIP Influencer Partnerships", value: "❌" },
        { label: "Competitor Analysis", value: "One time" },
        { label: "24/7 Monitoring", value: "❌" }
      ],

      ad_creation_optimization: [
        { label: "Ad Platforms Included", value: "FB, Insta or LinkedIn" },
        { label: "Ad Campaigns / Platform", value: "3" },
        { label: "Ad Designs", value: "6 Ads" },
        { label: "Ad Copywriting", value: "6 Ads" },
        { label: "Creative Refresh", value: "Quarterly" },
        { label: "A/B Testing", value: "❌" },
        { label: "Dynamic Creative Optimization", value: "❌" },
        { label: "Carousel Ads", value: "❌" },
        { label: "Video Ads", value: "❌" }
      ],

      targeting_and_retargting: [
        { label: "Geographic Targeting", value: "✔" },
        { label: "Demographic Targeting", value: "✔" },
        { label: "Interest-Based Targeting", value: "✔" },
        { label: "Behavioral Targeting", value: "✔" },
        { label: "Retargeting Campaign Setup", value: "✔" },
        { label: "Lookalike Audiences", value: "✔" },
        { label: "Budget Management", value: "✔" },
        { label: "Budget Allocation", value: "✔" },
        { label: "CPC Optimization", value: "❌" },
        { label: "CPA Optimization", value: "❌" }
      ],

      analytics_and_reporting: [
        { label: "Planning", value: "Basic" },
        { label: "Strategy", value: "Basic" },
        { label: "Real-Time Monitoring", value: "❌" },
        { label: "Weekly Performance Reports", value: "❌" },
        { label: "In-depth Monthly Reports", value: "✔" },
        { label: "Conversion Tracking", value: "Basic" },
        { label: "Daily Updates in Group", value: "❌" }
      ],

      support_and_consultation: [
        { label: "Phone Support", value: "✔" },
        { label: "Chat Support", value: "✔" },
        { label: "Email Support", value: "✔" },
        { label: "Monthly Strategy Consultation", value: "1 hour" },
        { label: "Priority Support", value: "❌" },
        { label: "PRP (Performance Review & Planning)", value: "Monthly" }
      ]
    },

    standard: {
      resources: [
        { label: "Dedicated Resources", value: "2" },
        { label: "Social Media Executive", value: "1" },
        { label: "Asst. Executive", value: "1" },
        { label: "Shared Resources", value: "2" },
        { label: "Account Manager", value: "❌" },
        { label: "Graphic Designer", value: "1" },
        { label: "Copy Writer", value: "1" }
      ],

      account_setup_and_integration: [
        { label: "Social Media Profiles Setup", value: "4 Platforms" },
        { label: "Integration with Website", value: "❌" },
        { label: "Number of Platforms", value: "4 Platforms" },
        { label: "Initial Setup & Strategy", value: "❌" },
        { label: "WhatsApp Group Creation - Team Collaboration", value: "✔" },
        { label: "Day Report for MOM Growth Comparison", value: "✔" },
        { label: "Business Brief Meeting", value: "✔" },
        { label: "Account Creation/Overhaul", value: "✔" },
        { label: "Audience Research", value: "Advanced" },
        { label: "Campaign Strategy Development", value: "Advanced" }
      ],

      content_creation_and_posting: [
        { label: "Content Calendar", value: "Bi-Weekly" },
        { label: "Posts per Month", value: "16" },
        { label: "Posting Frequency", value: "4 times/week" },
        { label: "Cover Photo & Profile Update", value: "Bi-Annual" },
        { label: "Stories Creation", value: "2 per month" },
        { label: "Interactive Posts (Polls, Quizzes)", value: "2 per month" },
        { label: "Video Posts", value: "2 per month" }
      ],

      engagement: [
        { label: "Direct Messaging / Response Handling", value: "Up to 1 per month" },
        { label: "Comment Response", value: "Manual" },
        { label: "Influencer Collaboration", value: "❌" },
        { label: "Group Creation & Management", value: "❌" },
        { label: "Community Group Engagement", value: "❌" }
      ],

      additional_features: [
        { label: "Social Media Training for Staff", value: "❌" },
        { label: "Crisis Management", value: "Basic" },
        { label: "Social Media Policy Development", value: "❌" },
        { label: "Multilingual Posts", value: "❌" },
        { label: "Platform-Specific Strategy (e.g., LinkedIn)", value: "❌" },
        { label: "VIP Influencer Partnerships", value: "❌" },
        { label: "Competitor Analysis", value: "Bi-Annual" },
        { label: "24/7 Monitoring", value: "❌" }
      ],

      ad_creation_optimization: [
        { label: "Ad Platforms Included", value: "FB, Insta or LinkedIn" },
        { label: "Ad Campaigns / Platform", value: "4" },
        { label: "Ad Designs", value: "8 Ads" },
        { label: "Ad Copywriting", value: "8 Ads" },
        { label: "Creative Refresh", value: "Quarterly" },
        { label: "A/B Testing", value: "❌" },
        { label: "Dynamic Creative Optimization", value: "❌" },
        { label: "Carousel Ads", value: "✔" },
        { label: "Video Ads", value: "❌" }
      ],

      targeting_and_retargting: [
        { label: "Geographic Targeting", value: "✔" },
        { label: "Demographic Targeting", value: "✔" },
        { label: "Interest-Based Targeting", value: "✔" },
        { label: "Behavioral Targeting", value: "✔" },
        { label: "Retargeting Campaign Setup", value: "✔" },
        { label: "Lookalike Audiences", value: "✔" },
        { label: "Budget Management", value: "✔" },
        { label: "Budget Allocation", value: "✔" },
        { label: "CPC Optimization", value: "✔" },
        { label: "CPA Optimization", value: "✔" }
      ],

      analytics_and_reporting: [
        { label: "Planning", value: "Intermediate" },
        { label: "Strategy", value: "Intermediate" },
        { label: "Real-Time Monitoring", value: "✔" },
        { label: "Weekly Performance Reports", value: "❌" },
        { label: "In-depth Monthly Reports", value: "✔" },
        { label: "Conversion Tracking", value: "Advanced" },
        { label: "Daily Updates in Group", value: "❌" }
      ],

      support_and_consultation: [
        { label: "Phone Support", value: "✔" },
        { label: "Chat Support", value: "✔" },
        { label: "Email Support", value: "✔" },
        { label: "Monthly Strategy Consultation", value: "2 hours" },
        { label: "Priority Support", value: "❌" },
        { label: "PRP (Performance Review & Planning)", value: "Monthly" }
      ]
    },

    advance: {
      resources: [
        { label: "Dedicated Resources", value: "2" },
        { label: "Social Media Executive", value: "1" },
        { label: "Asst. Executive", value: "1" },
        { label: "Shared Resources", value: "3" },
        { label: "Account Manager", value: "1" },
        { label: "Graphic Designer", value: "1" },
        { label: "Copy Writer", value: "1" }
      ],

      account_setup_and_integration: [
        { label: "Social Media Profiles Setup", value: "5 Platforms" },
        { label: "Integration with Website", value: "✔" },
        { label: "Number of Platforms", value: "5 Platforms" },
        { label: "Initial Setup & Strategy", value: "❌" },
        { label: "WhatsApp Group Creation - Team Collaboration", value: "✔" },
        { label: "Day Report for MOM Growth Comparison", value: "✔" },
        { label: "Business Brief Meeting", value: "✔" },
        { label: "Account Creation/Overhaul", value: "✔" },
        { label: "Audience Research", value: "Comprehensive" },
        { label: "Campaign Strategy Development", value: "Comprehensive" }
      ],

      content_creation_and_posting: [
        { label: "Content Calendar", value: "Weekly" },
        { label: "Posts per Month", value: "25" },
        { label: "Posting Frequency", value: "Daily" },
        { label: "Cover Photo & Profile Update", value: "Quarterly" },
        { label: "Stories Creation", value: "4 per month" },
        { label: "Interactive Posts (Polls, Quizzes)", value: "4 per month" },
        { label: "Video Posts", value: "4 per month" }
      ],

      engagement: [
        { label: "Direct Messaging / Response Handling", value: "Up to 5 per month" },
        { label: "Comment Response", value: "Manual" },
        { label: "Influencer Collaboration", value: "❌" },
        { label: "Goup creation & Management", value: "❌" },
        { label: "Community Group Engagement", value: "✔" }
      ],

      additional_features: [
        { label: "Social Media Training for Staff", value: "✔" },
        { label: "Crisis Management", value: "Advanced" },
        { label: "Social Media Policy Development", value: "❌" },
        { label: "Multilingual Posts", value: "Basic" },
        { label: "Platform-Specific Strategy (e.g., LinkedIn)", value: "Basic" },
        { label: "VIP Influencer Partnerships", value: "❌" },
        { label: "Competitor Analysis", value: "Quarterly" },
        { label: "24/7 Monitoring", value: "❌" }
      ],

      ad_creation_optimization: [
        { label: "Ad Plateforms Included", value: "FB, Insta & LinkedIn" },
        { label: "Ad Campaigns / Plateform", value: "6" },
        { label: "Ad Designs", value: "12 Ads" },
        { label: "Ad Copywriting", value: "12 Ads" },
        { label: "Creative Refresh", value: "Monthly" },
        { label: "A/B Testing", value: "✔" },
        { label: "Dynamic Creative Optimization", value: "✔" },
        { label: "Carousel Ads", value: "✔" },
        { label: "Video Ads", value: "✔" }
      ],

      targeting_and_retargting: [
        { label: "Geographic Targeting", value: "✔" },
        { label: "Demographic Targeting", value: "✔" },
        { label: "Interest-Based Targeting", value: "✔" },
        { label: "Behavioral Targeting", value: "✔" },
        { label: "Retargeting Campaign Setup", value: "✔" },
        { label: "Lookalike Audiences", value: "✔" },
        { label: "Budget Management", value: "✔" },
        { label: "Budget Allocation", value: "✔" },
        { label: "CPC Optimization", value: "✔" },
        { label: "CPA Optimization", value: "✔" }
      ],

      analytics_and_reporting: [
        { label: "Planning", value: "Advanced" },
        { label: "Strategy", value: "Advanced" },
        { label: "Real-Time Monitoring", value: "✔" },
        { label: "Weekly Performance Reports", value: "❌" },
        { label: "In-depth Monthly Reports", value: "✔" },
        { label: "Conversion Tracking", value: "Comprehensive" },
        { label: "Daily Updates in Group", value: "✔" }
      ],

      support_and_consultation: [
        { label: "Phone Support", value: "✔" },
        { label: "Chat Support", value: "✔" },
        { label: "Email Support", value: "✔" },
        { label: "Monthly Strategy Consultation", value: "4 hours" },
        { label: "Priority Support", value: "❌" },
        { label: "PRP (Performance Review & Planning)", value: "Monthly" }
      ]
    },

    enterprise: {
      resources: [
        { label: "Dedicated Resources", value: "2" },
        { label: "Social Media Executive", value: "1" },
        { label: "Asst. Executive", value: "1" },
        { label: "Shared Resources", value: "3" },
        { label: "Account Manager", value: "1" },
        { label: "Graphic Designer", value: "1" },
        { label: "Copy Writer", value: "1" }
      ],

      account_setup_and_integration: [
        { label: "Social Media Profiles Setup", value: "All Major Platforms" },
        { label: "Integration with Website", value: "Custom Integration" },
        { label: "Number of Platforms", value: "All Major Platforms" },
        { label: "Initial Setup & Strategy", value: "❌" },
        { label: "WhatsApp Group Creation - Team Collabration", value: "✔" },
        { label: "Day Report for MOM Growth Comparison", value: "✔" },
        { label: "Business Brief Meeting", value: "✔" },
        { label: "Account Creation/Overhaul", value: "✔" },
        { label: "Audience Research", value: "In-depth" },
        { label: "Campaign Strategy Development", value: "Customized" }
      ],

      content_creation_and_posting: [
        { label: "Content Calendar", value: "Daily" },
        { label: "Posts per Month", value: "5" },
        { label: "Posting Frequency", value: "Custom" },
        { label: "Cover Photo & Profile Update", value: "Monthly" },
        { label: "Stories Creation", value: "8 per month" },
        { label: "Interactive Posts (Polls, Quizzes)", value: "8 per month" },
        { label: "Video Posts", value: "8 per month" }
      ],

      engagement: [
        { label: "Direct Messaging / Response Handling", value: "Unlimited" },
        { label: "Comment Response", value: "Custom Responses" },
        { label: "Influencer Collaboration", value: "Custom Number Monthly" },
        { label: "Goup creation & Management", value: "✔" },
        { label: "Community Group Engagement", value: "✔" }
      ],

      additional_features: [
        { label: "Social Media Training for Staff", value: "✔" },
        { label: "Crisis Management", value: "Comprehensive" },
        { label: "Social Media Policy Development", value: "✔" },
        { label: "Multilingual Posts", value: "Included" },
        { label: "Platform-Specific Strategy (e.g., LinkedIn)", value: "Advanced" },
        { label: "VIP Influencer Partnerships", value: "Customized" },
        { label: "Competitor Analysis", value: "Monthly" },
        { label: "24/7 Monitoring", value: "✔" }
      ],

      ad_creation_optimization: [
        { label: "Ad Plateforms Included", value: "FB, Insta, LinkedIn & YouTube" },
        { label: "Ad Campaigns / Plateform", value: "Unlimited" },
        { label: "Ad Designs", value: "2+ Ads" },
        { label: "Ad Copywriting", value: "2+ Ads" },
        { label: "Creative Refresh", value: "As Needed" },
        { label: "A/B Testing", value: "✔" },
        { label: "Dynamic Creative Optimization", value: "✔" },
        { label: "Carousel Ads", value: "✔" },
        { label: "Video Ads", value: "✔" }
      ],

      targeting_and_retargting: [
        { label: "Geographic Targeting", value: "✔" },
        { label: "Demographic Targeting", value: "✔" },
        { label: "Interest-Based Targeting", value: "✔" },
        { label: "Behavioral Targeting", value: "✔" },
        { label: "Retargeting Campaign Setup", value: "✔" },
        { label: "Lookalike Audiences", value: "✔" },
        { label: "Budget Management", value: "✔" },
        { label: "Budget Allocation", value: "✔" },
        { label: "CPC Optimization", value: "✔" },
        { label: "CPA Optimization", value: "✔" }
      ],

      analytics_and_reporting: [
        { label: "Planning", value: "Comprehensive" },
        { label: "Strategy", value: "Comprehensive" },
        { label: "Real-Time Monitoring", value: "✔" },
        { label: "Weekly Performance Reports", value: "✔" },
        { label: "In-depth Monthly Reports", value: "Custom Reports" },
        { label: "Conversion Tracking", value: "Comprehensive" },
        { label: "Daily Updates in Group", value: "✔" }
      ],

      support_and_consultation: [
        { label: "Phone Support", value: "✔" },
        { label: "Chat Support", value: "✔" },
        { label: "Email Support", value: "✔" },
        { label: "Monthly Strategy Consultation", value: "8 hours" },
        { label: "Priority Support", value: "✔" },
        { label: "PRP (Performance Review & Planning)", value: "Monthly" }
      ]
    }

  };

  // Price table for each duration (from your screenshots / confirmed)
  const priceTable = {
    monthly: {
      lite: "₹15,000",
      standard: "₹25,000",
      advance: "₹50,000",
      enterprise: "₹100,000"
    },
    quarterly: {
      lite: "₹13,500",
      standard: "₹22,500",
      advance: "₹45,000",
      enterprise: "₹90,000"
    },
    halfyear: {
      lite: "₹12,000",
      standard: "₹20,000",
      advance: "₹40,000",
      enterprise: "₹80,000"
    },
    yearly: {
      lite: "₹10,500",
      standard: "₹17,500",
      advance: "₹35,000",
      enterprise: "₹70,000"
    }
  };

  // Build plans array from priceTable for the active tab
  const planMeta = [
    { id: "lite", title: "LITE", type: "Small Business" },
    { id: "standard", title: "STANDARD", type: "Moderate Competition" },
    { id: "advance", title: "ADVANCE", type: "Ecommerce / High Competition" },
    { id: "enterprise", title: "ENTERPRISE", type: "Brands / High Competition" }
  ];

  const plans = planMeta.map(p => ({
    id: p.id,
    title: p.title,
    price: priceTable[activeTab][p.id],
    type: p.type,
    features: (() => {
      if (p.id === "lite") return [
        "Dedicated Social Media Executive. Shared Graphic Designer, Copy W...",
        "Social Media profile setup on 4 platforms, no integration with we...",
        "Monthly Content calender, 8 posts/month, 2 times/week.",
        "3 Ad platforms, 3 campaigns, 6 ad designs & copywriting, Quarterl...",
        "1-hour monthly strategy consultation and PRP."
      ];
      if (p.id === "standard") return [
        "Dedicated Social Media Executive & Assistant. Shared Graphic Desi...",
        "Social media profile setup on 4 platforms, no integration with we...",
        "Bi-weekly content calendar, 16 posts/month, 4 times/week. Stories...",
        "3 Ad platforms,4 campaigns, 8 ad designs & copywriting, Quarterly...",
        "2 hours monthly strategy consultation and PRP."
      ];
      if (p.id === "advance") return [
        "Dedicated Social Media Executive & Assistant. Shared Account Mana...",
        "Social media profile setup on 5 platforms, integration with websi...",
        "Weekly content calendar, up to 25 posts/month, Daily posting. sto...",
        "3 Ad platforms, 6 campaigns, 12 ad designs & copywriting, Monthly...",
        "4 hours monthly strategy consultation and PRP."
      ];
      return [
        "Dedicated Social Media Executive & Assistant, Shared Account Mana...",
        "Social media profile setup on all major platforms, custom integra...",
        "Daily content calendar, up to 50 posts/month, custom posting. Sto...",
        "4 Ad platforms, unlimited campaigns, 20+ ad designs & copywriting...",
        "8 hours monthly strategy consultation, priority support, and PRP"
      ];
    })(),
    details: planDetails[p.id]
  }));

  return (
    <div className="pricing-wrapper">
      <section className="price-header" />
      <section className="price-header" />
      <section className="about-header">
        <div className="photo-text">SMM
          <p>
            Packages & Plans
          </p>
        </div>
      </section>

      <div className="tabs">
        {[
          { id: "monthly", label: <>Month <br /> (1 Month)</> },
          { id: "quarterly", label: <>Quarterly <br /> (3 Months)</> },
          { id: "halfyear", label: <>Half Yearly <br /> (6 Months)</> },
          { id: "yearly", label: <>Yearly <br /> (12 Months)</> },
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="plans-grid">
        {plans.map(plan => (
          <div key={plan.id} className="plan-card">
            {/* POPULAR TAG */}
            {plan.id === "standard" && <div className="popular-tag">Popular</div>}

            {/* DISCOUNT + PRICE */}
            <h3 className="plan-title">{plan.title}</h3>

            <div className="price-section">
              {/* Show original price & discount only if NOT monthly */}
              {activeTab !== "monthly" && (
                <>
                  <p className="original-price">
                    ₹{(() => {
                      const monthlyPrices = {
                        lite: 15000,
                        standard: 25000,
                        advance: 50000,
                        enterprise: 100000
                      };

                      // Multiplying months so original price = base × months
                      const multipliers = {
                        quarterly: 1,
                        halfyear: 1,
                        yearly: 1
                      };

                      return (monthlyPrices[plan.id] * multipliers[activeTab]).toLocaleString();
                    })()}
                  </p>

                  {/* Dynamic discount badge */}
                  <span className="discount-badge">
                    {activeTab === "quarterly" && "10% Off"}
                    {activeTab === "halfyear" && "20% Off"}
                    {activeTab === "yearly" && "30% Off"}
                  </span>
                </>
              )}
            </div>

            <h2 className="plan-price">{plan.price}</h2>
            <p className="per-month">/Month</p>
            <button className="quote-btn">Get Quote</button>

            <hr className="divider" />
            <p className="plan-type">{plan.type}</p>

            <ul className="feature-list">
              {plan.features.map((f, idx) => (
                <li key={idx}>{f}</li>
              ))}
            </ul>

            <button className="details-btn" onClick={() => setSelectedPlan(plan)}>
              <span className="details-btn-txt">View Details</span>
            </button>
          </div>

        ))}
      </div>

      {selectedPlan && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="close-btn" onClick={() => setSelectedPlan(null)}><IoMdClose /></button>
            <h2 className="popup-title">{selectedPlan.title}</h2>

            <div className="popup-grid">

              {/* Resources */}
              <div className="card">
                <h3 className="popup-subtitle">Resources</h3>
                <ul>
                  {(selectedPlan?.details?.resources || []).map((r, i) => (
                    <li key={i}>
                      <span className="left">{r.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{r.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Account Setup & Integration */}
              <div className="card">
                <h3 className="popup-subtitle">Account Setup & Integration</h3>
                <ul>
                  {(selectedPlan?.details?.account_setup_and_integration || []).map((item, i) => (
                    <li key={i}>
                      <span className="left">{item.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{item.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Content Creation & Posting */}
              <div className="card">
                <h3 className="popup-subtitle">Content Creation & Posting</h3>
                <ul>
                  {(selectedPlan?.details?.content_creation_and_posting || []).map((item, i) => (
                    <li key={i}>
                      <span className="left">{item.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{item.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Engagement */}
              <div className="card">
                <h3 className="popup-subtitle">Engagement</h3>
                <ul>
                  {(selectedPlan?.details?.engagement || []).map((item, i) => (
                    <li key={i}>
                      <span className="left">{item.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{item.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Additional Features */}
              <div className="card">
                <h3 className="popup-subtitle">Additional Features</h3>
                <ul>
                  {(selectedPlan?.details?.additional_features || []).map((item, i) => (
                    <li key={i}>
                      <span className="left">{item.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{item.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Ads */}
              <div className="card">
                <h3 className="popup-subtitle">Ad Creation & Optimization</h3>
                <ul>
                  {(selectedPlan?.details?.ad_creation_optimization || []).map((item, i) => (
                    <li key={i}>
                      <span className="left">{item.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{item.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Targeting */}
              <div className="card">
                <h3 className="popup-subtitle">Targeting & Retargeting</h3>
                <ul>
                  {(selectedPlan?.details?.targeting_and_retargting || []).map((item, i) => (
                    <li key={i}>
                      <span className="left">{item.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{item.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Reporting */}
              <div className="card">
                <h3 className="popup-subtitle">Analytics & Reporting</h3>
                <ul>
                  {(selectedPlan?.details?.analytics_and_reporting || []).map((item, i) => (
                    <li key={i}>
                      <span className="left">{item.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{item.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Support */}
              <div className="card">
                <h3 className="popup-subtitle">Support & Consultation</h3>
                <ul>
                  {(selectedPlan?.details?.support_and_consultation || []).map((item, i) => (
                    <li key={i}>
                      <span className="left">{item.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{item.value}</span>
                    </li>
                  ))}
                </ul>
              </div>

            </div>


            <a
              href={`https://wa.me/919624883636?text=${encodeURIComponent(
                `Hi! I'm interested in the ${selectedPlan.title} plan (${activeTab.toUpperCase()}). Please share more details.`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="subscribe-btn"
            >
              Subscribe Now
            </a>

          </div>
        </div>
      )}
    </div>
  );
}
